import { render, staticRenderFns } from "./ShippingHeaderPagination.vue?vue&type=template&id=74a77394"
import script from "./ShippingHeaderPagination.vue?vue&type=script&lang=js"
export * from "./ShippingHeaderPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports